import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

export const Root = ({ children }: { children: React.ReactNode }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  padding: 13px 16px 0 16px;
  position: relative;
  border-top: 1px solid ${vars.v3Color.gray100};
  transform: translateZ(0);
  backface-visibility: hidden;
`;
